
define('template!sdsPaymentThirdpartyRegisterTest',[''],function(template){return '<md-button ng-click="vm.Go()">Here we go!</md-button>\r\n<p ng-if="vm.DoingTheThing.IsActive">busy</p>\r\n<pre>{{vm.Result}}</pre>';});

